/* eslint-disable */
export interface EnumItem {
  key: string;
  value: number;
}
export function enumToArray<T>(Enum: T): EnumItem[] {
  const items: EnumItem[] = [];
  const keys = Object.keys(Enum).map((k) => Enum[k]);
  for (const elem of keys) {
    if (typeof elem === 'number') {
      const enumItem: EnumItem = { key: Enum[elem], value: elem };
      items.push(enumItem);
    }
  }
  return items;
}
